module.exports = __webpack_public_path__ + "img/Penny-Hat-03.0836db9f.jpg";